import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" id=\"close--sprite\">\n<line x1=\"16.1676\" y1=\"0.636396\" x2=\"1.16765\" y2=\"15.6364\" stroke-width=\"1.2\" />\n<line x1=\"15.8324\" y1=\"15.6364\" x2=\"0.97369\" y2=\"0.777732\" stroke-width=\"1.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol